import angular from 'angular';

import ValidationMessageComponent from './validation-message.cmpt';

export default angular
    .module('application.component.validation-message', [])
    .component(ValidationMessageComponent.selector, ValidationMessageComponent);



// WEBPACK FOOTER //
// ./src/application/component/validation-message/index.js